import React, { useEffect, useState } from 'react';
import { MenuForm } from '../Menu.js';
import "../../css/main.css"
import { SecurityElement } from '../elements/security_element.js';
import { useAPICall } from '../../hooks/useAPICall.js';
import { PageMenuElement } from '../elements/page_menu.js';

export function HomeForm() 
{    
    const [pageData, setPageData] = useState();
    
    
    const handleDataFetch = (data) =>
    {
        setPageData(data);
        
    
    }
    const {MakeCall} = useAPICall();
    
 
    function onPageMenuClick(onclickname) {
            }


            useEffect(()=>
            {                
                MakeCall('home/gethomepage', "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\"}", handleDataFetch);
            });
          
    return (
        <div>
            {SecurityElement(pageData)}
            {MenuForm()}                   
            <div className="contentdiv">
            {PageMenuElement("PRC Membership App", [], onPageMenuClick, false)}        
            <div className='formbox'>
                    <div className='formtitle' >Home</div>
                     
                <p>You can use this app to check on your visits, update your information and view messages from Membership.</p>
                <p>If you spot any errors in your memmbership data or problems with the page, please email <a href='mailto:membership@peverilrifleclub.im' style={{"color" : "darkblue"}}>membership@peverilrifleclub.im</a></p>
                
                </div>
            </div>
        </div>);
  

 
}